import { Checkbox, DatePicker } from "antd";
import { ErrorMessage, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as Yup from "yup";
import {
  Input,
  SelectInput,
} from "../../../../../_metronic/_partials/controls";
import API from "../../../../helpers/devApi";
import { swalConfirm, swalError, swalSuccess } from "../../../../helpers/swal";
import * as Action from "../../../applicant/_redux/applicantActions";
import moment from "moment";

const _init = {
  title: "",
  year: "",
  organisations: "",
  country_id: "",
  authors: "",
  url: "",
  citation: "",
};

const Publication = () => {
  const { id } = useParams();
  const [publicationData, setPublicationData] = useState();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const {
    countryList,
    publicationList,
    employeeProfile,
    personalInfo,
  } = useSelector(
    ({ applicant, employeeList }) => ({
      employeeProfile: employeeList.employeeProfile,
      countryList: applicant.countryList,
      publicationList: applicant.publicationList,
      personalInfo: applicant.personal_info,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(Action.getAllCountry());
    if (id) {
      dispatch(Action.getPublicationListForApplicant(id));
      dispatch(Action.getApplicantPersonalInfo(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (publicationList && publicationList.length > 0) {
      const data = publicationList?.map((item) => {
        return {
          id: item?.hrms_publication__id,
          title: item?.hrms_publication__title,
          year: item?.hrms_publication__year,
          organisations: item?.hrms_publication__organisations,
          authors: item?.hrms_publication__authors,
          url: item?.hrms_publication__url,
          citation: item?.hrms_publication__citation,
        };
      });
      setPublicationData({ list: data });
    } else {
      // setPublicationData({ list: [_init] });
      setPublicationData({ list: [] });
    }
  }, [publicationList]);

  //console.log({ publicationList })

  // Validation schema
  const validationSchema = Yup.object().shape({
    list: Yup.array().of(
      Yup.object().shape({
        title: Yup.string().required("title is required"),
        year: Yup.string().required("publication year is required"),
        organisations: Yup.string().required("organisations is required"),
        authors: Yup.string().required("authors is required"),
        // url: Yup.string().required("url is required"),
      })
    ),
  });

  const handleSaveProfile = async (values) => {
    const formData = values?.list?.map((item) => {
      return {
        title: item?.title,
        authors: item?.authors,
        url: item?.url,
        organisations: item?.organisations,
        year: item?.year,
        applicant_id: id,
        citation: item?.citation,
      };
    });

    if (id) {
      const apiUrl = `/hrms_publication/store`;
      // const apiUrl = `http://localhost:6003/api/v1/hrms_publication/store`;
      await API.post(apiUrl, { applicant_id: id, publications: formData })
        .then(async (res) => {
          if (res.data.success) {
            await dispatch(Action.getPublicationListForApplicant(id));
            dispatch(Action.getApplicantPersonalInfo(id));
            swalSuccess("Publications Information Updated Successfully!!");
            setLoading(false);
          } else {
            swalError("something went wrong");
          }
        })
        .catch((error) => {
          console.error(error);
        });
      setLoading(false);
    }
  };

  const handleDelete = async (itemId, index) => {
    swalConfirm().then(async (res) => {
      if (res.isConfirmed) {
        const list = publicationData?.list;
        list.splice(index, 1);
        setPublicationData({ list: list });
      }
    });
  };

  const handleAdd = async (values) => {
    // const list = publicationData?.list;
    // let data = [...list, _init];
    const newArray = [...values.list];
    let data = [...newArray, _init];
    setPublicationData({ list: data });
  };

  const handleOnChangeNoPublicantion = (no_research) => {
    const api = `/hrms_applicant/${id}`;
    // const api = `http://localhost:6003/api/v1/hrms_applicant/${id}`;
    API.patch(api, { no_research })
      .then((res) => {
        if (res.data.success) {
          swalSuccess("Data updated successfully");
          if (no_research == 1) {
            dispatch(
              Action.createProfileScore(
                {
                  name: ["Publication"],
                  applicant_id: id,
                },
                () => {
                  dispatch(Action.getApplicantPersonalInfo(id));
                }
              )
            );

            dispatch(
              Action.createProfileScore(
                {
                  name: ["Publication Summary"],
                  applicant_id: id,
                },
                () => {
                  dispatch(Action.getApplicantPersonalInfo(id));
                }
              )
            );
          } else {
            dispatch(
              Action.updateProfileScore(
                {
                  name: ["Publication"],
                  applicant_id: id,
                },
                () => {
                  dispatch(Action.getApplicantPersonalInfo(id));
                }
              )
            );
            dispatch(
              Action.updateProfileScore(
                {
                  name: ["Publication Summary"],
                  applicant_id: id,
                },
                () => {
                  dispatch(Action.getApplicantPersonalInfo(id));
                }
              )
            );
          }
        } else {
          if (res.data.message) {
            swalError(res.data.message);
          } else {
            swalError("something went wrong");
          }
        }
      })
      .catch((error) => {
        console.log(error);
        swalError("something went wrong");
      });
  };

  return (
    <div className="card card_body_box mb-5">
      <Formik
        enableReinitialize
        initialValues={publicationData}
        validationSchema={validationSchema}
        onSubmit={(values, { resetForm }) => {
          handleSaveProfile(values, resetForm);
        }}
      >
        {({ handleSubmit, setFieldValue, values, errors, touched }) => (
          <Form>
            <div className="row">
              <div className="col-md-12">
                <div className="card_header_with_edit_btn">
                  <div className="title">
                    <h2>Research & Publication</h2>
                  </div>
                </div>

                <hr />
              </div>
            </div>
            {values?.list?.map((item, i, row) => (
              <div className="row" key={i}>
                <div className="col-md-12 mb-4">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <Input
                            name={`list[${i}].title`}
                            label={"Publication Title"}
                            isRequired
                            value={item.title}
                            onChange={(e) => {
                              setFieldValue(`list[${i}].title`, e.target.value);
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].title`} />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <Input
                            name={`list[${i}].authors`}
                            label={"Authors"}
                            isRequired
                            value={item.authors}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].authors`,
                                e.target.value
                              );
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].authors`} />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="required">Year</label>
                          <DatePicker
                            onChange={(year, yearStr) => {
                              setFieldValue(`list[${i}].year`, yearStr);
                            }}
                            value={item.year ? moment(item.year) : null}
                            style={{ width: "100%" }}
                            picker="year"
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].year`} />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <Input
                            name={`list[${i}].organisations`}
                            label={"Publisher/Institute/Organization"}
                            isRequired
                            value={item.organisations}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].organisations`,
                                e.target.value
                              );
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].organisations`} />
                          </div>
                        </div>
                        {/* <div className="col-md-6 mb-3">
                          <SelectInput
                            name={`list[${i}].country_id`}
                            label={"Country"}
                            options={countryList}
                            isRequired
                            value={item.country_id}
                            onChange={(value) => {
                              setFieldValue(`list[${i}].country_id`, value);
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].country_id`} />
                          </div>
                        </div> */}
                        <div className="col-md-6 mb-3">
                          <Input
                            name={`list[${i}].url`}
                            label={"Publication Link"}
                            value={item.url}
                            onChange={(e) => {
                              setFieldValue(`list[${i}].url`, e.target.value);
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].url`} />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <Input
                            name={`list[${i}].citation`}
                            label={"Citation/Other Remarks"}
                            value={item.citation}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].citation`,
                                e.target.value
                              );
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].citation`} />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 mb-3 d-flex">
                          {i === values?.list?.length - 1 && (
                            <button
                              type="button"
                              className="btn  add-button btn-sm text-white mr-5 text-nowrap"
                              onClick={() => {
                                handleAdd(values);
                              }}
                            >
                              <i
                                className="fa fa-plus text-white"
                                aria-hidden="true"
                              ></i>
                              Add Publication
                            </button>
                          )}

                          <button
                            type="button"
                            className="btn btn-danger btn-sm  text-nowrap"
                            onClick={() => {
                              handleDelete(item.id, i);
                            }}
                          >
                            <i
                              className="fa fa-minus  text-white"
                              aria-hidden="true"
                            ></i>
                            Remove Publication
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {!values?.list?.length && (
              <div className="row">
                <div
                  className="col-md-12"
                  style={{ display: "flex", gap: "2" }}
                >
                  {!personalInfo?.no_research ? (
                    <button
                      type="button"
                      className="btn  add-button btn-sm text-white mr-5 text-nowrap"
                      onClick={() => {
                        handleAdd(values);
                      }}
                    >
                      <i
                        className="fa fa-plus text-white"
                        aria-hidden="true"
                      ></i>
                      Add Publication
                    </button>
                  ) : (
                    <></>
                  )}
                  <div className="align-content-center">
                    <Checkbox
                      type="checkbox"
                      checked={personalInfo?.no_research}
                      id="no_research"
                      onChange={(e) => {
                        handleOnChangeNoPublicantion(e.target.checked ? 1 : 0);
                      }}
                    />
                    <label
                      className="form-check-label ml-2"
                      htmlFor="no_research"
                    >
                      <b>Don't have any research and publication?</b>
                    </label>
                  </div>
                </div>
              </div>
            )}

            <div className="edit_btn_group d-flex modal-footer m-0 p-0">
              {/* <button className='btn btn-default mr-4' >Cancel</button> */}
              {!personalInfo?.no_research ? (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  Save
                </button>
              ) : (
                <></>
              )}
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Publication;
